"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.ApplicationUseCases = void 0;
const Agile_1 = require("./Agile");
const Interceptors_1 = require("./Interceptors");
const ApplicationServices_1 = require("../services/ApplicationServices");
class ApplicationUseCases {
    constructor(instanceConfig) {
        const appServices = new ApplicationServices_1.ApplicationServices(instanceConfig);
        const endpointClient = appServices.getEndpointClient();
        const endpointInterceptor = appServices.getEndpointInterceptor();
        this.agile = new Agile_1.Agile(endpointClient);
        this.interceptors = new Interceptors_1.Interceptors(endpointClient, endpointInterceptor);
    }
}
exports.ApplicationUseCases = ApplicationUseCases;
//# sourceMappingURL=ApplicationUseCases.js.map